import baseApi from '../baseApi';

export default {
  init() {
    return baseApi.get('/api-article/delivery-set-complete/v1/init');
  },
  printCredits(form) {
    return baseApi.post(`/api-article/delivery-set-complete/v1/print-credits`, form);
  }
}
